import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pedidos-provimento-13--sprite",
  "use": "pedidos-provimento-13--sprite-usage",
  "viewBox": "0 0 21 24",
  "content": "<symbol viewBox=\"0 0 21 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"pedidos-provimento-13--sprite\">\n<path d=\"M8.53125 18.6667H12.4687V15.3333H15.75V11.3333H12.4687V8H8.53125V11.3333H5.25V15.3333H8.53125V18.6667ZM0 24V8L10.5 0L21 8V24H0ZM2.625 21.3333H18.375V9.33333L10.5 3.33333L2.625 9.33333V21.3333Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol